import React from 'react';
import { Modal, Button, Form, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Close from "../../images/close-icon.svg";
import DistanceImage3 from "../../images/circumferenceimg.png";

const CircumferenceModal = ({ showModal, onClose }) => {

  return (
    <Modal
      show={showModal}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
      contentClassName="password-modal-content"
      dialogClassName="password-modal-dialog"
    >
      <Link
        variant=""
        onClick={onClose}
        className="modal-close-floating"
        aria-label="Close"
      >
        <Image src={Close} alt="" />
      </Link>

      <Modal.Body className="password-modal-body p-0">
        <div className="head-bg">
          <h5 className="password-modal-title">Circumference</h5>
        </div>
        <div className="inner-modal-content inner-radius">

          <Image src={DistanceImage3} alt="" className="info-icon" />
          <p className="password-modal-description mt-4">
            In EEG (electroencephalogram) testing, head circumference is a relevant factor, particularly when using the standard 10-20 system for electrode placement. The 10-20 system is a standardized method that uses percentages of the  head's circumference to determine electrode placement, ensuring  consistent and reproducible recordings.
          </p>



        </div>

      </Modal.Body>
    </Modal>
  );
};

export default CircumferenceModal;

